"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatestPatientClosureHistory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LatestPatientClosureHistory_Factory = /** @class */ (function () {
    function LatestPatientClosureHistory_Factory() {
    }
    LatestPatientClosureHistory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUserId: model.CreatedByUserId,
            PatientId: model.PatientId,
            PatientName: model.PatientName,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
        };
        return result;
    };
    LatestPatientClosureHistory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUserId: model.CreatedByUserId,
            PatientId: model.PatientId,
            PatientName: model.PatientName,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
        };
        return result;
    };
    return LatestPatientClosureHistory_Factory;
}());
exports.LatestPatientClosureHistory_Factory = LatestPatientClosureHistory_Factory;
